// @flow
export const phoneNumberMask = [0, " ", "(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/];


// WEBPACK FOOTER //
// ./src/Constants/GlobalVariables/InputMasks.js